import { render } from "./TabsPage.vue?vue&type=template&id=16e77566&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Luis\\Documents\\Code\\LEAGUES\\creator-app-3\\creator-app\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__